import AppView from "./AppContainer";

export default AppView;
